const chartOptions = (isDisplayLabel = true) => {
    return {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: isDisplayLabel
            }
        },
        tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest"
        },
        responsive: true,
        scales: {
            yAxes: [
                {
                    barPercentage: 1.6,
                    gridLines: {
                        drawBorder: false,
                        color: "rgba(29,140,248,0.0)",
                        zeroLineColor: "transparent"
                    },
                    ticks: {
                        suggestedMin: 60,
                        suggestedMax: 125,
                        padding: 20,
                        fontColor: "#9a9a9a"
                    }
                }
            ],
            xAxes: [
                {
                    barPercentage: 1.6,
                    gridLines: {
                        drawBorder: false,
                        color: "rgba(29,140,248,0.1)",
                        zeroLineColor: "transparent"
                    },
                    ticks: {
                        padding: 20,
                        fontColor: "#9a9a9a"
                    }
                }
            ]
        }
    };
}

const buildChart = (labels = [], _datasets = [[], []], names = ["Time period - Current Month", "Time period - 30 days ago"]) => {
    return (canvas) => {
        if (!canvas) return
        let ctx = canvas.getContext("2d");

        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
        gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
        gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors
        names = ["Time period - Current Month", "Time period - 30 days ago"]
        if (names[1] === "Time period - 30 days ago") {
            names[1] = "Time period - " + String(_datasets[0].length) + " days ago"
        }

        return {
            labels: labels,
            datasets: [
                {
                    label: names[0],
                    fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: "#25D366",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "#25D366",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#25D366",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: _datasets[0]
                },
                {
                    label: names[1],
                    fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: "#CF4D4D",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "#CF4D4D",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#CF4D4D",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: _datasets[1]
                }
            ]
        };
    }
};

const buildChartV2 = (labels = [], _datasets = [[], []], names = []) => {
    return (canvas) => {
        if (!canvas) return
        let ctx = canvas.getContext("2d");

        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
        gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
        gradientStroke.addColorStop(0, "rgba(29,140,248,0)");

        var colorArr = ["#25D366", "#CF4D4D", "#25D36680", "#CF4D4D80"]
        if (names.length === 0) {
            names = []
            names.push("Synced")
            names.push("Synced - Last " + String(_datasets[0].length) + " days ago")
            names.push("Non-Synced ")
            names.push("Non-Synced - Last " + String(_datasets[0].length) + " days ago")
        }
        var datasets = []

        for (let i = 0; i < _datasets.length; i++) {
            datasets.push({
                label: names[i],
                fill: false,
                backgroundColor: gradientStroke,
                borderColor: colorArr[i],
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: colorArr[i],
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: colorArr[i],
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: _datasets[i]
            })
        }

        return {
            labels: labels,
            datasets: datasets
        }
    }
};

const buildSignUpPercentChart = (labels = [], _datasets = [[], []], names = []) => {
    return (canvas) => {
        if (!canvas) return
        let ctx = canvas.getContext("2d");

        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
        gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
        gradientStroke.addColorStop(0, "rgba(29,140,248,0)");

        var colorArr = ["#25D366", "#CF4D4D"]
        if (names.length === 0) {
            names = []
            names.push("SignUp Synced %")
            names.push("SignUp Synced % - Last " + String(_datasets[0].length) + " days ago")
        }
        var datasets = []

        for (let i = 0; i < 2; i++) {
            var _data = []
            for (let j = 0; j < _datasets[i * 2].length; j += 1) {
                var _total = _datasets[i][j] + _datasets[i + 2][j]
                if (_total === 0) _data.push(0)
                else _data.push(_datasets[i][j] * 100 / (_total))
            }
            datasets.push({
                label: names[i],
                fill: false,
                backgroundColor: gradientStroke,
                borderColor: colorArr[i],
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: colorArr[i],
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: colorArr[i],
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: _data
            })
        }

        return {
            labels: labels,
            datasets: datasets
        }
    }
};

const buildPlayerMinsChart = (labels = [], _datasets = { 'Mini': [], 'Large': [] }) => {
    return (canvas) => {
        if (!canvas) return
        let ctx = canvas.getContext("2d");

        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
        gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
        gradientStroke.addColorStop(0, "rgba(29,140,248,0)");

        var colorArr = ["#2536D3", "#33D325", "#D32525"]
        var names = ["Mini", "Large", "Total"]
        var datasets = []
        _datasets['All'] = []
        for (let i = 0; i < _datasets['Mini'].length; i++) {
            _datasets['All'].push(_datasets['Mini'][i] + _datasets['Large'][i])
        }
        var _key = ["Mini", "Large", "All"]

        for (let i = 0; i < 3; i++) {
            datasets.push({
                label: names[i],
                fill: false,
                backgroundColor: gradientStroke,
                borderColor: colorArr[i],
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: colorArr[i],
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: colorArr[i],
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: _datasets[_key[i]]
            })
        }

        return {
            labels: labels,
            datasets: datasets
        }
    }
};

const parseCustomTime = (customDateTime, timeZone = 0) => {
    if (customDateTime) {
        customDateTime = customDateTime.replace("GMT", "")
        var dateTime = new Date(customDateTime);
        dateTime.setTime(dateTime.getTime() + timeZone * 3600 * 1000);
        return dateTime.toString().replace(/\([^()]*\)/g, '').substring(4, 24)
    }
    return ""
}

const utils_StringIsNullOrEmpty = (value) => {
    return value == null || value === "";
}

module.exports = {
    buildChart,
    buildChartV2,
    buildSignUpPercentChart,
    buildPlayerMinsChart,
    chartOptions,
    parseCustomTime,
    utils_StringIsNullOrEmpty
};
